export default {
  modalTitle: {
    id: 'shipping_zip_modal_title',
    defaultMessage: 'Delivery estimate',
  },
  modalCloseA11y: {
    id: 'shipping_zip_modal_close_a11y',
    defaultMessage: 'Close',
  },
  shipToLabel: {
    id: 'shipping_zip_ship_to_postal_code',
    defaultMessage: 'Ship to {postalCode, html}',
  },
  updateLabel: {
    id: 'shipping_zip_update_label',
    defaultMessage: 'Update ZIP code',
  },
  switchCountryTitle: {
    id: 'shipping_zip_modal_switch_country_title',
    defaultMessage: 'Switch country',
  },
  switchCountryBackA11y: {
    id: 'shipping_zip_modal_switch_country_back_a11y',
    defaultMessage: 'Back',
  },
  successTitle: {
    id: 'shipping_zip_success_title',
    defaultMessage: 'ZIP code updated',
  },
  successDescription: {
    id: 'shipping_zip_success_description',
    defaultMessage:
      'You have the most accurate delivery estimation for your order.',
  },
}
